/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Package_UndeliverableInputs */

const tr_geliver_substatus_package_undeliverable = /** @type {(inputs: Geliver_Substatus_Package_UndeliverableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslim Edilemez`)
};

const en_geliver_substatus_package_undeliverable = /** @type {(inputs: Geliver_Substatus_Package_UndeliverableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undeliverable`)
};

const de_geliver_substatus_package_undeliverable = /** @type {(inputs: Geliver_Substatus_Package_UndeliverableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht zustellbar`)
};

const ru_geliver_substatus_package_undeliverable = /** @type {(inputs: Geliver_Substatus_Package_UndeliverableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не поддаётся доставке`)
};

/**
* | output |
* | --- |
* | "Undeliverable" |
*
* @param {Geliver_Substatus_Package_UndeliverableInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_package_undeliverable = /** @type {((inputs?: Geliver_Substatus_Package_UndeliverableInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Package_UndeliverableInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_package_undeliverable(inputs)
	if (locale === "de") return de_geliver_substatus_package_undeliverable(inputs)
	if (locale === "ru") return ru_geliver_substatus_package_undeliverable(inputs)
	return tr_geliver_substatus_package_undeliverable(inputs)
});